import { render, staticRenderFns } from "./choose-us.vue?vue&type=template&id=5cf66cb9&scoped=true&"
var script = {}
import style0 from "./choose-us.vue?vue&type=style&index=0&id=5cf66cb9&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf66cb9",
  null
  
)

export default component.exports